import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
/*
* Copyright (c) 2021 RCSB PDB and contributors, licensed under MIT, See LICENSE file for more info.
* @author Joan Segura Mora <joan.segura@rcsb.org>
*/
import * as React from "react";
import { TagDelimiter } from "@rcsb/rcsb-api-tools/build/RcsbUtils/TagDelimiter";
import { rcsbRequestCtxManager } from "@rcsb/rcsb-saguaro-app/lib/RcsbRequest/RcsbRequestContextManager";
export class MsaRowTitleCheckboxComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            checked: this.props.tag == "aligned",
            opacity: (this.props.disabled) && this.props.tag != "aligned" ? 0 : 1
        };
    }
    render() {
        return (_jsx("div", { style: this.style(), onClick: () => { this.click(); }, title: this.title() }));
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscribe();
            this.requestInfo();
            this.setState({ opacity: yield this.opacity() });
        });
    }
    componentWillUnmount() {
        this.subscription.unsubscribe();
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.props.disabled && prevProps.disabled)
                this.requestInfo();
        });
    }
    subscribe() {
        this.subscription = this.props.stateManager.subscribe((o) => {
            if (o.type == "representation-change" && o.view == "3d-view" && o.data)
                this.structureViewerRepresentationChange(o.data);
            if (o.type == "component-info" && o.view == "3d-view" && o.data)
                this.componentInfo(o.data);
        });
    }
    structureViewerRepresentationChange(d) {
        const row = d.label.split(TagDelimiter.entity);
        const suffix = row.pop();
        const entryId = row.join(TagDelimiter.entity);
        const entityId = suffix.substring(0, 1);
        if (this.compId() == `${entryId}${TagDelimiter.entity}${entityId}`) {
            //TODO this is a one to many relationship
            /*if( d.label.includes("polymer") && this.props.tag == "polymer" && d.isHidden == this.state.checked){
                this.setState({checked:!this.state.checked});
            }
            if( !d.label.includes("polymer") && this.props.tag == "non-polymer" && d.isHidden == this.state.checked){
                this.setState({checked:!this.state.checked});
            }*/
        }
    }
    click() {
        if (this.props.disabled)
            return;
        this.setState({ checked: !this.state.checked }, () => {
            this.props.stateManager.next({
                view: "1d-view",
                type: "representation-change",
                data: {
                    pdb: "entityId" in this.props ? {
                        entryId: this.props.entryId,
                        entityId: this.props.entityId,
                    } : {
                        entryId: this.props.entryId,
                        instanceId: this.props.instanceId
                    },
                    isHidden: !this.state.checked,
                    tag: this.props.tag
                }
            });
        });
    }
    style() {
        const color = {
            "checked": "rgb(51, 122, 183)",
            "unchecked": "rgba(51,122,183,0.44)",
            "disabled": "#ddd"
        };
        return {
            width: 7,
            height: 7,
            opacity: this.state.opacity,
            backgroundColor: this.props.disabled ? color.disabled : color[this.state.checked ? "checked" : "unchecked"],
            border: 1,
            borderStyle: "solid",
            borderColor: this.props.disabled ? color.disabled : color.checked,
            display: "inline-block",
            marginLeft: 4,
            cursor: this.props.disabled ? undefined : "pointer"
        };
    }
    title() {
        if (this.props.disabled)
            return undefined;
        switch (this.props.tag) {
            case "aligned":
                return `${this.state.checked ? "Hide" : "Show"} Aligned Polymer Chain`;
            case "polymer":
                return `${this.state.checked ? "Hide" : "Show"} Other Polymer Chains`;
            case "non-polymer":
                return `${this.state.checked ? "Hide" : "Show"} Non-polymer Chains`;
        }
    }
    compId() {
        if ("entityId" in this.props)
            return `${this.props.entryId}${TagDelimiter.entity}${this.props.entityId}`;
        else
            return `${this.props.entryId}${TagDelimiter.instance}${this.props.instanceId}`;
    }
    getRcsbId(pdb) {
        if ("entityId" in pdb)
            return `${pdb.entryId}${TagDelimiter.entity}${pdb.entityId}`;
        else
            return `${pdb.entryId}${TagDelimiter.instance}${pdb.instanceId}`;
    }
    componentInfo(data) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.compId() == this.getRcsbId(data.pdb) && this.props.tag == data.tag) {
                if (data.isVisible)
                    this.setState({ checked: true, opacity: yield this.opacity() });
                else
                    this.setState({ checked: false, opacity: yield this.opacity() });
            }
        });
    }
    requestInfo() {
        this.props.stateManager.next({
            type: "component-info",
            view: "1d-view",
            data: {
                pdb: "entityId" in this.props ? {
                    entryId: this.props.entryId,
                    entityId: this.props.entityId,
                } : {
                    entryId: this.props.entryId,
                    instanceId: this.props.instanceId
                },
                tag: this.props.tag
            }
        });
    }
    opacity() {
        return __awaiter(this, void 0, void 0, function* () {
            switch (this.props.tag) {
                case "aligned":
                    return 1;
                case "polymer":
                    return (yield this.polymerTest()) ? 1 : 0;
                case "non-polymer":
                    return (yield this.nonPolymerTest()) ? 1 : 0;
            }
        });
    }
    polymerTest() {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            const entryId = this.props.entryId;
            const entryInfo = (yield rcsbRequestCtxManager.getEntryProperties(entryId))[0];
            if (entryInfo && entryInfo.entityToInstance.size > 1)
                return true;
            if (entryInfo && entryInfo.entityToInstance && Array.from((_a = entryInfo.entityToInstance.get(this.compId())) !== null && _a !== void 0 ? _a : []).length > 1)
                return true;
            if (entryInfo && ((_f = (_e = (_c = (_b = entryInfo.instanceToOperator) === null || _b === void 0 ? void 0 : _b.get(`${this.props.entryId}-1`)) === null || _c === void 0 ? void 0 : _c.get(((_d = entryInfo.entityToInstance.get(this.compId())) !== null && _d !== void 0 ? _d : [""])[0])) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0) > 1)
                return true;
            return false;
        });
    }
    nonPolymerTest() {
        return __awaiter(this, void 0, void 0, function* () {
            const entryId = this.props.entryId;
            const entryInfo = (yield rcsbRequestCtxManager.getEntryProperties(entryId))[0];
            return entryInfo && entryInfo.nonPolymerEntityToInstance && entryInfo.nonPolymerEntityToInstance.size > 0;
        });
    }
}
